import { Status, StatusGroup } from '~api/som_search';

import { type LocalizationKey } from '~src/i18n/use-translation';
import { ShipmentStatuses } from '~src/utils/status-helpers';

type StatusGroupWithoutUnknown = Exclude<StatusGroup, 'UNKNOWN_GROUP'>;

export type GroupType = StatusGroupWithoutUnknown extends `${infer U}_GROUP` ? U : never;

interface Group {
  label: LocalizationKey;
  group: GroupType;
}

export const MAX_GROUP_SIZE = 100;

export const GroupStatus: Record<GroupType, Status[]> = {
  ALL: ShipmentStatuses,
  CREATED: ['CREATED'],
  BOOKED: ['BOOKED', 'BOOKING_RECEIVED_BY_CARRIER'],
  PICKUP: ['PICKUP_BOOKED', 'PICKUP_REGISTERED', 'PICKUP_REQUESTED', 'PICKUP_SCHEDULED'],
  IN_TRANSIT: ['DELIVERY_IN_PROGRESS', 'IN_CUSTOMS', 'IN_TRANSIT'],
  ERROR: ['INVALID_BOOKING', 'DAMAGED', 'ERROR', 'FAILED', 'LOST', 'UNDELIVERABLE', 'CANCEL_FAILED'],
  OTHER: [
    'NOTIFICATION_SENT',
    'ARRIVED_AT_PICKUP_POINT',
    'INSTORE_ARRIVED_AT_PICKUP_POINT',
    'FORWARDED_TO_THIRD_PARTY',
    'INSTORE_PARCEL_RETURNED',
    'PICKED_UP',
    'DELIVERED',
    'INSTORE_PARCEL_PICKED_UP',
    'CANCELED',
    'CONTACT_CARRIER_SUPPORT',
    'CONTACT_MERCHANT_SUPPORT',
    'DELAYED',
    'PICKUP_DELAYED',
    'REDIRECTED',
    'RETURNED_TO_SENDER',
    'RETURNED',
    'INSTORE_PARCEL_REFUSED',
    'INSTORE_PARCEL_OVERDUE',
    'INSTORE_PARCEL_RELOCATED',
    'INFO',
    'UNKNOWN',
  ],
};

export const Groups: Group[] = [
  {
    label: 'shipments.list.groupAll',
    group: 'ALL',
  },
  {
    label: 'shipments.list.groupCreated',
    group: 'CREATED',
  },
  {
    label: 'shipments.list.groupBooked',
    group: 'BOOKED',
  },
  {
    label: 'shipments.list.groupPickup',
    group: 'PICKUP',
  },
  {
    label: 'shipments.list.groupInTransit',
    group: 'IN_TRANSIT',
  },
  {
    label: 'shipments.list.groupOther',
    group: 'OTHER',
  },
  {
    label: 'shipments.list.groupError',
    group: 'ERROR',
  },
];
